import React, { Fragment, useEffect, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';

export const WithBackBtHandeling: React.FC<{
    close: () => void;
    whoAmI?: string;
    goBackOnUnMount?: boolean;
    isReplace?: boolean;
}> = ({ close, children, whoAmI = 'dialog', goBackOnUnMount = true, isReplace = false }) => {
    const history = useHistory();
    const location = useLocation();

    const [initalLocationSearch, setInitalLocationSearch] = useState('');

    let previousSearch: string | undefined;

    useEffect(() => {
        setInitalLocationSearch(location.search);
        (isReplace ? history.replace : history.push)(
            `${location.pathname}${location.search ? `${location.search}&` : '?'}${whoAmI}=true`,
        );
        previousSearch = window.location.search;

        return () => {
            if (goBackOnUnMount) {
                if (window.location.search.toString().includes(`${whoAmI}=true`)) {
                    history.goBack();
                }
            }
        };
    }, []);

    useEffect(() => {
        if (!location.search && previousSearch) {
            previousSearch = location.search;
            return;
        }

        if (location.search.length === 0 && !previousSearch) {
            close();
        } else if (initalLocationSearch === location.search) {
            close();
            // history.replace(`${location.pathname}${initalLocationSearch}`);
        }
    }, [location.search]);

    return <Fragment>{children}</Fragment>;
};
